import { Grid } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import React, { useEffect, useState } from 'react';
import { injectIntl } from "react-intl";
import { useDispatch } from 'react-redux';
import { Portlet } from '../../../partials/content/Portlet';
import { get, getClaimAllDetails, getClaimComments, getHistory, resetClaimLineItem, setClaimComments, setClaimCommentsConfirmationDialog } from '../../../store/actions/claimAnalysis';
import { tiny } from '../../../store/actions/contracts';
import { BasicDetailsSection } from './BasicDetailsSection';
import { ClaimAdjustments } from './ClaimAdjustments';
import { ClaimLineItemSection } from './ClaimLineItemSection.js';
import { CommentsForm } from './CommentsForm';
import ServiceAdjustments from './ServiceAdjustments';
import { useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import { ChatSidebarWrapper } from '../../contractsPage/ChatSidebarWrapper';

const EMPTY_ARRAY = [];

const useStyles = makeStyles(theme => {
    return {
        portlet: {
            'box-shadow': 'none',
        },
        lineItemGrid: {
            padding: '0px 24px',
        },
        lineItemBox: {
            padding: '0 24px 24px 24px',
            border: '1px solid #E0E0E0',
            borderRadius: '8px',
            maxHeight: '500px',
            overflowX: 'hidden',
            overflowY: 'auto',
        },
        commentsBox: {
            marginTop: '16px',
            marginBottom: '24px',
            padding: '12px 24px',
            border: '1px solid #E0E0E0',
            borderRadius: '8px',
        }
    }
});

function ClaimViewPage({ intl, match }) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const claimId = match.params.id;
    const currentLocation = useLocation().pathname;

    // Sidebar state
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [sidebarExpanded, setSidebarExpanded] = useState(false);
    const [sidebarData, setSidebarData] = useState<{
        contractId: number;
        sessionId: number;
        directoryId: string;
        claimNumber: string;
    } | null>(null);

    const openChat = (data) => {
        setSidebarData(data);
        setSidebarOpen(true);
    };

    const closeChat = () => {
        setSidebarOpen(false);
        setSidebarExpanded(false);
        setSidebarData(null);
    };

    useEffect(() => {
        dispatch(tiny());
        dispatch(getClaimAllDetails(claimId));
        dispatch(get(claimId));
        
        dispatch(getClaimComments(claimId));
        dispatch(setClaimCommentsConfirmationDialog({ open: false, state: '' }));
        dispatch(setClaimComments(''));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [claimId]);

    const refreshLineItems = () => {
        dispatch(resetClaimLineItem());
        dispatch(get(claimId));
    }

    const reprocessClaimCallback = () => {
        refreshLineItems();
        dispatch(getHistory(claimId));
        dispatch(getClaimAllDetails(claimId));
        dispatch(getClaimComments(claimId));
    }
    const assignClaimsCallback = () => {
        dispatch(getClaimAllDetails(claimId));
        dispatch(getClaimComments(claimId));

    }

    return (
        <Box sx={{ 
            display: 'flex', 
            flexDirection: 'row', 
            width: '100%', 
            height: sidebarOpen ? 'calc(100vh - 120px)' : 'auto',
            alignItems: 'flex-start',
            gap: 0,
            overflow: sidebarOpen ? 'hidden' : 'visible',
        }}>
            {/* Main content area */}
            <Box sx={{ 
                flex: sidebarExpanded ? 0 : 1,
                minWidth: 0,
                height: sidebarOpen ? '100%' : 'auto',
                opacity: sidebarExpanded ? 0 : 1,
                width: sidebarExpanded ? 0 : 'auto',
                overflow: sidebarExpanded ? 'hidden' : (sidebarOpen ? 'auto' : 'visible'),
                transition: 'all 0.3s ease-in-out',
            }}>
                <Portlet className={classes.portlet}>

                    <BasicDetailsSection 
                        isFromTriage={currentLocation?.includes("confidence-score-triage") ?? false} 
                        isFromClaimAnalysis={currentLocation?.includes("claimAnalysis") ?? false} 
                        reprocessClaimCallback={reprocessClaimCallback} 
                        claimId={claimId} 
                        assignClaimsCallback={assignClaimsCallback}
                        openChat={openChat}
                        closeChat={closeChat}
                    />

                    <Grid className={classes.lineItemGrid}>
                        <Grid>
                            <ClaimLineItemSection refreshLineItems={refreshLineItems} />
                        </Grid>
                        <Grid className={classes.commentsBox}>
                            <CommentsForm claimId={claimId} />
                        </Grid>
                    </Grid>
                </Portlet>
                <ClaimAdjustments claimId={claimId}/>
                <ServiceAdjustments claimId={claimId}/>
            </Box>

            {/* Chat Sidebar */}
            {sidebarOpen && sidebarData && (
                <ChatSidebarWrapper 
                    open={sidebarOpen}
                    onClose={() => {
                        setSidebarOpen(false);
                        setSidebarExpanded(false);
                        setSidebarData(null);
                    }}
                    contractId={sidebarData.contractId}
                    sessionId={sidebarData.sessionId}
                    directoryId={sidebarData.directoryId}
                    claimNumber={sidebarData.claimNumber}
                    selected={EMPTY_ARRAY}
                    chatType="claim"
                    isExpanded={sidebarExpanded}
                    onExpandToggle={() => setSidebarExpanded(prev => !prev)}
                    isPatientDetailsVisible={true}
                />
            )}
        </Box>
    )
}

export default injectIntl(ClaimViewPage);
